import React from "react";
import { useController, useFormState } from "react-hook-form";
import _ from "lodash";

import { BaseFormComponentProps, HookFormComponentProps } from "../types";

export function withHookForm<P extends BaseFormComponentProps, T = any>(
  Component: React.ComponentType<P>,
) {
  const HookFormComponent = React.forwardRef<any, HookFormComponentProps<P>>(
    (props, ref) => {
      const { name, control, ...rest } = props as HookFormComponentProps<P>;
      const { errors } = useFormState({
        control,
        name,
      });

      const { field } = useController({
        name,
        control,
      });

      const componentProps = {
        ...rest,
        name,
        control,
        value: field.value,
        onChange: (value: any) => {
          if (value === undefined) {
            const defaultValue = _.get(control._defaultValues, name);
            field.onChange(defaultValue);
          } else {
            field.onChange(value);
          }
        },
        onBlur: field.onBlur,
        error: _.get(errors, name),
        ref,
      } as unknown as P;

      return <Component {...componentProps} />;
    },
  );

  HookFormComponent.displayName = `withHookForm(${
    Component.displayName || Component.name || "Component"
  })`;

  return React.memo(HookFormComponent);
}
export function createHookFormComponent<
  P extends BaseFormComponentProps,
  T = any,
>(Component: React.ComponentType<P>) {
  return withHookForm<P, T>(Component);
}
